import { takeEvery, put, call, all } from "redux-saga/effects";
import { getFirstMessage } from "../../Helpers";
import { loading, alert, services, watchApiResponse } from "../../Utils";
import * as c from "./constant";

function* getList({ args }) {
  yield put(loading("ATTACHMENT_ALL"));
  const response = yield call(services.get(`api/attachment`), args);
  yield call(watchApiResponse, response, function* () {
    const { data } = response.data;
    return yield put({
      type: c.GOT_LIST,
      data: data,
    });
  });
}

function* getDocTypes() {
  yield put(loading("DOC_TYPE"));
  const response = yield call(services.get(`api/doctypes`));
  yield call(watchApiResponse, response, function* () {
    const { data } = response.data;
    return yield put({
      type: c.GOT_DOC_TYPES,
      data: data,
    });
  });
}

function* create({ args }) {
  const response = yield call(services.post(`api/attachment`), args);
  yield call(watchApiResponse, response, function* () {
    const { message } = response.data;
    alert.success(message);
    yield getList({ args: {} });
    yield put({
      type: "MODAL",
      data: {
        isOpen: false,
      },
    });
  });
}
function* unSave({ id }) {
  const response = yield call(services.get(`api/doctypes${id}/unsave`));
  yield call(watchApiResponse, response, function* () {
    const { message } = response.data;
    alert.success(message);
    yield getList({ args: {} });
  });
}

export default function* authSaga() {
  yield all([
    takeEvery(c.GET_LIST, getList),
    takeEvery(c.GET_DOC_TYPES, getDocTypes),
    takeEvery(c.CREATE, create),
  ]);
}
